const AUTH_KEYS = {
  AUTH_INVALID: "auth.invalid",
  AUTH_EMAIL_EXIST: "auth.emailExist",
  AUTH_NOT_FOUND: "auth.notFound",
  AUTH_TOO_MANY: "auth.tooMany",
  AUTH_REGISTER_FAIL: "register.fail",
};

export function generateAuthError(message) {
  switch (message) {
    case "INVALID_PASSWORD":
      return "AUTH_INVALID";
    case "EMAIL_EXIST":
      return "AUTH_EMAIL_EXIST";
    case "EMAIL_NOT_FOUND":
      return "AUTH_NOT_FOUND";
    default:
      return "AUTH_TOO_MANY";
  }
}

export function authErrorText(t, message) {
  const key = AUTH_KEYS[message];
  return key ? t(key) : message;
}
